"use client";

import { datadogRum } from "@datadog/browser-rum";
import { isRscPayloadFetchError } from "./isRscPayloadFetchError";

if (process.env.NEXT_PUBLIC_ENV === "prod") {
  datadogRum.init({
    applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID as string,
    clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN as string,
    site: process.env.NEXT_PUBLIC_DATADOG_SITE as string,
    service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
    env: "production",
    version: process.env.NEXT_PUBLIC_DATADOG_VERSION,
    sessionSampleRate: 20,
    sessionReplaySampleRate: 20,
    startSessionReplayRecordingManually: true,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    beforeSend: (event) => {
      if (event.type === "error") {
        const message = event.error?.message ?? "";
        if (isRscPayloadFetchError(message)) {
          return false;
        }
      }
      return true;
    },
  });

  datadogRum.startSessionReplayRecording();
}

export default function DatadogInit() {
  // doc: https://docs.datadoghq.com/real_user_monitoring/guide/monitor-your-nextjs-app-with-rum/?tab=npm
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
